import startsWith from 'lodash/startsWith';
const withPrefix = require('./withPrefix').default;

export default function SafePrefix(url) {
	if (startsWith(url, '#') || startsWith(url, 'http')) {
		return url;
	}
	return withPrefix(url);
}
